module.exports = __webpack_public_path__ + "static/media/joundcom.48c4a4a2.jpg";